let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5JIp8")).then(() => parcelRequire('ff6WO'));